// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.background-half{
    background-color: rgba(0,0,0,0.5);
    /* background-color: red; */
}
.dropdown-menu.show {
  background-color: black;
  padding: 0.5vw;
  padding-bottom: 0.8vw;
  border-radius: 0px !important;
}

.customDropdown .dropdown-item:hover {
  background-color: black !important;
  color: white !important;
}

.slide-in-blurred-top {
	animation: slide-in-left 0.6s cubic-bezier(0.230, 1.000, 0.320, 1.000) both;
}

.slide-out-blurred-top {
	animation: slide-out-left 0.45s cubic-bezier(0.755, 0.050, 0.855, 0.060) both;
}
  @keyframes slide-out-left {
    0% {
      transform: translateX(0);
      opacity: 1;
    }
    100% {
      transform: translateX(-1000px);
      opacity: 0;
    }
  }
  @keyframes slide-in-left {
    0% {
      transform: translateX(-1000px);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }`, "",{"version":3,"sources":["webpack://./src/view/css/navbar.css"],"names":[],"mappings":"AAAA;IACI,iCAAiC;IACjC,2BAA2B;AAC/B;AACA;EACE,uBAAuB;EACvB,cAAc;EACd,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;CAES,2EAA2E;AACpF;;AAEA;CAES,6EAA6E;AACtF;EAaE;IACE;MAEU,wBAAwB;MAChC,UAAU;IACZ;IACA;MAEU,8BAA8B;MACtC,UAAU;IACZ;EACF;EAcA;IACE;MAEU,8BAA8B;MACtC,UAAU;IACZ;IACA;MAEU,wBAAwB;MAChC,UAAU;IACZ;EACF","sourcesContent":[".background-half{\n    background-color: rgba(0,0,0,0.5);\n    /* background-color: red; */\n}\n.dropdown-menu.show {\n  background-color: black;\n  padding: 0.5vw;\n  padding-bottom: 0.8vw;\n  border-radius: 0px !important;\n}\n\n.customDropdown .dropdown-item:hover {\n  background-color: black !important;\n  color: white !important;\n}\n\n.slide-in-blurred-top {\n\t-webkit-animation: slide-in-left 0.6s cubic-bezier(0.230, 1.000, 0.320, 1.000) both;\n\t        animation: slide-in-left 0.6s cubic-bezier(0.230, 1.000, 0.320, 1.000) both;\n}\n\n.slide-out-blurred-top {\n\t-webkit-animation: slide-out-left 0.45s cubic-bezier(0.755, 0.050, 0.855, 0.060) both;\n\t        animation: slide-out-left 0.45s cubic-bezier(0.755, 0.050, 0.855, 0.060) both;\n}\n@-webkit-keyframes slide-out-left {\n    0% {\n      -webkit-transform: translateX(0);\n              transform: translateX(0);\n      opacity: 1;\n    }\n    100% {\n      -webkit-transform: translateX(-1000px);\n              transform: translateX(-1000px);\n      opacity: 0;\n    }\n  }\n  @keyframes slide-out-left {\n    0% {\n      -webkit-transform: translateX(0);\n              transform: translateX(0);\n      opacity: 1;\n    }\n    100% {\n      -webkit-transform: translateX(-1000px);\n              transform: translateX(-1000px);\n      opacity: 0;\n    }\n  }\n\n  @-webkit-keyframes slide-in-left {\n    0% {\n      -webkit-transform: translateX(-1000px);\n              transform: translateX(-1000px);\n      opacity: 0;\n    }\n    100% {\n      -webkit-transform: translateX(0);\n              transform: translateX(0);\n      opacity: 1;\n    }\n  }\n  @keyframes slide-in-left {\n    0% {\n      -webkit-transform: translateX(-1000px);\n              transform: translateX(-1000px);\n      opacity: 0;\n    }\n    100% {\n      -webkit-transform: translateX(0);\n              transform: translateX(0);\n      opacity: 1;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
